<template lang="pug">
  include ./../../../mixins
  +b.popup-inner.thx_modal
    +e.close-popup.js-close(@click='$emit("close")')
    +e.text-content
      +b.g-row--appearance_column
        +b.el
          +b.P.ds-caption--size_4xl-md.--size_2md.--w_sb.--c_blue.tac
            | {{message.header}}
        +b.el--p_t_sm
          +b.P.ds-caption--size_1md-md.--size_10xs.--w_m.--c_blue.tac
            | {{message.text}}

</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/Modals/ModalAnswer.vue